import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

async function registerPeriodicSync() {
  if (!("serviceWorker" in navigator)) return;
  if (!("periodicSync" in ServiceWorkerRegistration.prototype)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    await reg.periodicSync.register("schedule-refresh", {
      minInterval: 12 * 60 * 60 * 1000, // минимум раз в 12 часов
    });
  } catch {}
}

registerPeriodicSync();
